import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../Common/Logo';
import Icon from '../Common/Icon';
import { useUI } from '../../contexts/UIContext';

export const PUBLIC_PAGE_NAV_ITEMS = [
  { page: 'about', label: 'About' },
  { page: 'science', label: 'Science' },
  { page: 'resources', label: 'Resources' },
  { page: 'help', label: 'Help' },
  { page: 'privacy', label: 'Privacy' },
  { page: 'terms', label: 'Terms' },
];

const PublicPageHeader = ({
  onNavigateHome,
  onNavigatePage,
  activePage = '',
  tagline = 'Live curious. Test ideas. Grow.',
  backLabel = 'Back home',
  compact = false,
}) => {
  const { darkMode, setDarkMode, setThemePreferenceForScope, setThemeScope } = useUI();

  const handleThemeToggle = () => {
    const nextPreference = darkMode ? 'light' : 'dark';
    setThemeScope('marketing');
    setThemePreferenceForScope('marketing', nextPreference);
    setDarkMode(nextPreference === 'dark');
    try {
      localStorage.setItem('thryveloop_theme_preference_marketing_v1', nextPreference);
      localStorage.setItem('thryveloop_theme_preference', nextPreference);
      localStorage.setItem('thryveloop_darkMode', String(nextPreference === 'dark'));
      localStorage.setItem('thryveloop-theme', nextPreference);
    } catch (_) {
      // ignore localStorage write errors
    }
  };

  return (
    <header className={`page-header ${compact ? 'page-header--compact' : ''}`}>
      <nav className={`page-nav ${compact ? 'page-nav--compact' : ''}`}>
        <button onClick={onNavigateHome} className="nav-brand-button" type="button">
          <Logo size={compact ? 36 : 40} />
          <div className="brand-info">
            <h1 className="brand-title">ThryveLoop</h1>
            <p className="brand-tagline">{tagline}</p>
          </div>
        </button>

        <div className="page-nav-pages" aria-label="Public pages">
          {PUBLIC_PAGE_NAV_ITEMS.map((item) => (
            <button
              key={item.page}
              type="button"
              className={`page-nav-page ${activePage === item.page ? 'active' : ''}`}
              onClick={() => {
                if (typeof onNavigatePage === 'function') {
                  onNavigatePage(item.page);
                } else {
                  onNavigateHome();
                }
              }}
              aria-current={activePage === item.page ? 'page' : undefined}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="nav-links">
          <button
            type="button"
            className="page-theme-toggle"
            onClick={handleThemeToggle}
            aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            <Icon name={darkMode ? 'sun' : 'moon'} size={18} />
          </button>
          <button onClick={onNavigateHome} className="nav-link nav-link-back" type="button">
            {backLabel}
          </button>
        </div>
      </nav>
    </header>
  );
};

PublicPageHeader.propTypes = {
  onNavigateHome: PropTypes.func.isRequired,
  onNavigatePage: PropTypes.func,
  activePage: PropTypes.string,
  tagline: PropTypes.string,
  backLabel: PropTypes.string,
  compact: PropTypes.bool,
};

export default PublicPageHeader;
